module.exports = __webpack_public_path__ + "static/media/admissionExam.dc96a929.svg";